// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State, Callback } from '../types.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default <T extends State>(key: string, callback: Callback): Action<T> =>
	({ setState, getState }): void => {
		if (!getState()[key]) return;

		const slice = new Set(getState()[key]);
		slice.delete(callback);

		// @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Set<unknown>; }' is not assignable to parameter of type 'Partial<T>'.
		setState({ [key]: slice });
	};
